import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Grid, Paper, Box, Button } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { ValidationError } from '../ValidationError';
import { LANGUAGES } from '../../constants';

export const PromotionBanners = ({ formData, onFileUpload, errors = {} }) => {
  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
          Баннер акции
        </Typography>
        <Grid container spacing={3}>
          {LANGUAGES.map((lang) => {
            const fieldName = `banner_${lang.value}`;
            const hasError = !!errors[fieldName];
            
            return (
              <Grid item xs={12} md={4} key={lang.value}>
                <Box>
                  <Paper
                    elevation={1}
                    sx={{
                      border: hasError ? '2px dashed #f44336' : '2px dashed #e0e0e0',
                      p: 3,
                      textAlign: 'center',
                      borderRadius: 2,
                      backgroundColor: hasError ? '#ffebee' : 'transparent',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        borderColor: hasError ? '#f44336' : 'primary.main',
                        backgroundColor: hasError ? '#ffebee' : 'primary.50'
                      }
                    }}>
                    {formData[fieldName] ? (
                      <Box>
                        <img
                          src={
                            typeof formData[fieldName] === 'string'
                              ? formData[fieldName]
                              : URL.createObjectURL(formData[fieldName])
                          }
                          alt={`Banner ${lang.label}`}
                          style={{
                            maxWidth: '100%',
                            maxHeight: '200px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                          }}
                        />
                        <Button
                          onClick={() => onFileUpload(fieldName, null)}
                          size="small"
                          color="error"
                          sx={{ mt: 2 }}
                          variant="outlined">
                          Удалить
                        </Button>
                      </Box>
                    ) : (
                      <Box>
                        <CloudUpload sx={{ fontSize: 48, color: hasError ? 'error.main' : 'primary.main', mb: 2 }} />
                        <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
                          Загрузить баннер ({lang.label})
                        </Typography>
                        <input
                          type="file"
                          accept=".jpg,.png,.webp"
                          onChange={(e) => onFileUpload(fieldName, e.target.files[0])}
                          style={{ display: 'none' }}
                          id={`banner-${lang.value}`}
                        />
                        <label htmlFor={`banner-${lang.value}`}>
                          <Button
                            component="span"
                            variant="contained"
                            startIcon={<CloudUpload />}
                            sx={{ borderRadius: 2 }}>
                            Выбрать файл
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Paper>
                  <ValidationError error={errors[fieldName]} />
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};

PromotionBanners.propTypes = {
  formData: PropTypes.object.isRequired,
  onFileUpload: PropTypes.func.isRequired,
  errors: PropTypes.object
};
